import styled from 'styled-components'

export const WorkInProgressViewContainer = styled.div`
  display: flex;
  width: 100%;
  gap: 1rem;
  align-items: flex-start;
  justify-content: center;
  height: 100%;
`
